import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosParametrizacionCompaniaMixin = {
  computed: {
    permisosParametrizacionCompania() {
      return {
        accesoModulo: tienePermiso('generales'),
        crearCompania: tienePermiso('crearGenerales'),
        actualizarCompania: tienePermiso('actualizarGenerales'),
        verCompania: tienePermiso('verGenerales'),
      };
    },
  },
};
